import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Cancelar encomenda',
  title: 'Nunca rejeite de forma leviana!',
  text: 'Se houver um problema menor com a encomenda, contacte o cliente e resolva-o.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Artigos esgotados',
    [OrderRejectionReason.ClosingSoon]: 'Loja fechada',
    [OrderRejectionReason.StoryBusy]: 'Loja demasiado ocupada',
    [OrderRejectionReason.CustomerMistake]: 'Cliente ligou para cancelar',
    [OrderRejectionReason.DriverNotArrived]: 'Estafeta não chegou',
  },
  buttons: {
    confirm: 'Confirmar',
  },
};
